export enum DesktopPreviewDevice {
  Mobile = 'mobile',
  Desktop = 'desktop',
}
